<template>
  <div>
    <v-card min-height="600">
      <!-- overlay loading -->
      <v-overlay absolute color="grey lighten-4" v-if="isLoading" opacity="1">
        <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
      </v-overlay>
      <v-card-text>
        <div class="flex justify-between" v-if="false">
          <div>
            <h3>{{ $t('asset.asset_list') }}</h3>
          </div>
          <div>
            <v-btn elevation="0" color="info" @click="showCheckListForm(true, false, false, '')">
              <v-icon left>mdi-devices</v-icon>{{ $t('asset.add_list') }}
            </v-btn>
          </div>
        </div>
        <div class="py-3" v-if="contractAssets && false">
          <div
            class="bg-gray-50 rounded-lg border-l-4 border-green-600 p-5 mb-2"
            v-for="(ca , index) in contractAssets"
            :key="`ca_${index}`"
          >
            <div class="flex justify-between items-center">
              <div>
                <div class="text-xl">{{ ca.area.name || "-" }}</div>
                <div>{{ $t('market.total_list', { count: ca.assets.length || 0 }) }}</div>
              </div>
              <div>
                <v-btn elevation="0" rounded small @click="ca.isShow = !ca.isShow">{{ $t('detail') }}</v-btn>
              </div>
            </div>
            <template v-if="ca.isShow">
              <v-divider class="my-2"></v-divider>
              <div>
                <div class="text-lg" v-for="(item, index) in ca.assets" :key="`asset_${index}`">
                  <div
                    class="px-3 py-1 rounded-md flex justify-between items-center hover:bg-white transition-all"
                  >
                    <div>{{ item.asset ? item.asset.name : '-' }}</div>
                    <div class="grid grid-cols-3 gap-2">
                      <v-btn
                        color="info"
                        small
                        elevation="0"
                        @click="
                          showCheckListForm(false, false, true, item.objectId)
                        "
                      >{{ $t('image') }}</v-btn>
                      <v-btn
                        color="warning"
                        small
                        elevation="0"
                        @click="
                          showCheckListForm(false, true, false, item.objectId)
                        "
                      >{{ $t('action_type.edit') }}</v-btn>
                      <v-btn color="error" small elevation="0" @click="preDelete(item.objectId)">{{ $t('action_type.delete') }}</v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            class="p-5 bg-gray-50 rounded-lg text-center text-lg"
            v-if="contractAssets.length < 1"
          >{{ $t('asset.no_asset_list_in_contract') }}</div>
        </div>
        <div>
          <div class="flex justify-space-between">
            <div class="flex align-center">
              <h3>{{ $t('asset.asset_list') }}</h3>
              <!-- <v-btn
                color="info"
                class="ml-2"
                @click="setSelectAreas(true)"
                v-if="isSelect"
              >เลือกทั้งหมด</v-btn>
              <v-btn
                color="warning"
                class="ml-2"
                @click="setSelectAreas(false)"
                v-if="isSelect"
              >ไม่เลือกทั้งหมด</v-btn>-->
            </div> 
            <div>
               <v-btn
                  color="info"
                  class="ml-2"
                  @click="showCheckListForm(true, false, false, '');"
                >
                  <v-icon class="me-2">mdi-plus-box-multiple-outline</v-icon>
                  {{ $t('area.add_multiple_stall') }}
                </v-btn>
              <!-- <v-btn color="info" v-if="!isSelect" @click="isSelect = !isSelect">
                <v-icon class="me-2">mdi-plus-box-multiple-outline</v-icon>เลือกเพิ่มหลายแผง
              </v-btn>
              <template v-if="isSelect">
                <v-btn
                  color="info"
                  class="ml-2"
                  @click="showCheckListForm(true, false, false, '')"
                  :disabled="countSelect() == 0"
                >
                  <v-icon class="me-2">mdi-plus</v-icon>
                  เพิ่มรายการ {{countSelect()}} แผง
                </v-btn>
                <v-btn color="error" class="ml-2" @click="isSelect = false; setSelectAreas(false)">
                  <v-icon class="me-2">mdi-close</v-icon>ยกเลิก
                </v-btn>
              </template> -->
            </div>
          </div>
          <div
            class="flex justify-space-between my-2 p-5 bg-gray-100"
            style="border-radius: 15px;"
            v-for="area of areaItems"
            :key="area.objectId"
          >
            <div class="flex align-center">
              <v-checkbox
                flat
                solo
                hide-details
                style="margin:0 10px 0 0;"
                v-if="isSelect && !isToggle"
                v-model="selectAreas[area.objectId].isSelect"
                @click="isToggle = true;isToggle = false"
              ></v-checkbox>
              <div style="width:auto;border-left:2px solid gray;padding-left:10px;">
                <h3>{{ $t('area.space') }} {{area.name}}</h3>
                <div class="pl-2">
                  <template v-if="contractAssetObject[area.objectId]">
                    <div
                      class="flex justify-space-between"
                      v-for="ca of contractAssetObject[area.objectId].assets"
                      :key="`asset-${ca.objectId}`"
                    >
                      <div class="flex justify-space-between align-center" style="border-bottom:1px solid #5555550F;">
                        <div style="min-width:100px;margin-right:15px;">{{ca.asset.name}}</div>
                        <div>{{ca.cost | currencySuffixSign}}</div>
                      </div>
                      <div class="ml-2">
                        <v-btn
                          color="warning"
                          icon
                          small
                          :disabled="isSelect"
                          @click="
                          selectAreas[area.objectId].isSelect = true ;
                          showCheckListForm(false, true, false, ca.objectId)
                        "
                        >
                          <v-icon size="20">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn
                          color="error"
                          icon
                          small
                          :disabled="isSelect"
                          @click="preDelete(ca.objectId)"
                        >
                          <v-icon size="20">mdi-close</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </template>
                  <div class="text-gray-400 mt-2" v-else>{{ $t('asset.no_asset_list_in_stall') }}</div>
                </div>
              </div>
            </div>
            <div class="grid">
              <v-btn
                color="info"
                small
                class="my-1"
                :disabled="isSelect"
                @click="showCheckListForm(true, false, false, '',area.objectId)"
              >
                <v-icon class="me-2">mdi-plus</v-icon>{{ $t('asset.add_list') }}
              </v-btn>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <check-list-form
      v-model="isCheckList"
      :isCreate="checkList.isCreate"
      :isUpdate="checkList.isUpdate"
      :isDisable="checkList.isDisable"
      :objectId="checkList.objectId"
      :haveAreas="areaIds"
      @onSave="onSaveChecklist"
    ></check-list-form>
    <confirm-dialog
      :type="`error`"
      v-model="isDeleteAsset"
      @onOk="confirmRemove()"
      :title="`${$t('validate.question_confirm_delete')}`"
      :text="`${$t('validate.want_delete')}`"
    ></confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CheckListForm from "./CheckListForm.vue";
import ConfirmDialog from "./ConfirmDialog.component.vue";
export default {
  components: { CheckListForm, ConfirmDialog },
  computed: {
    ...mapGetters({
      getAreas: "contract/getAreas",
      contractAssets: "contractAsset/getContractAssets"
    }),
    areaItems() {
      let areas = [];
      for (let area of this.getAreas) {
        this.selectAreas[area.objectId] = { isSelect: false };
        areas.push(area);
      }
      return areas.sort(function(a, b) {
        if (b.order > a.order) return -1;
        else return 1;
      });
    },
    contractAssetObject() {
      let res = {};
      if (this.contractAssets) {
        for (const contractAsset of this.contractAssets) {
          res[contractAsset.area.objectId] = contractAsset;
        }
      }
      return res;
    }
  },
  data() {
    return {
      isCheckList: false,
      checkList: {
        isCreate: false,
        isUpdate: false,
        objectId: null,
        isDisable: false,
        areas: []
      },
      areaIds:[],
      isDeleteAsset: false,
      isLoading: false,
      isSelect: false,
      selectAreas: {},
      isToggle: false
    };
  },
  props: {
    contractId: {
      type: String,
      required: true
    },
    check: Number
  },
  mounted() {
    if (this.contractId) this.getContractAssetsByContract();
  },
  watch: {
    contractId(data) {
      this.getContractAssetsByContract();
    },
    isCheckList(value) {
      if (!value) {
        this.isSelect = false;
        this.setSelectAreas(false);
      }
    }
  },
  methods: {
    showCheckListForm(isCreate, isUpdate, isDisable, objectId , areaId) {
      this.checkList.isCreate = isCreate;
      this.checkList.isUpdate = isUpdate;
      this.checkList.isDisable = isDisable;
      this.checkList.objectId = objectId;
      this.checkList.areas = 
      this.areaIds = areaId ? [areaId] : [];
      // for (const key in this.selectAreas) {
      //   let selectArea = this.selectAreas[key];
      //   if (selectArea.isSelect) this.checkList.areas.push(key);
      // }
      this.isCheckList = true;
    },
    async getContractAssetsByContract() {
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          "contractAsset/getContractAssetsByContract",
          { contractId: this.contractId }
        );
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async confirmRemove() {
      await this.removeContractAsset();
      await this.getContractAssetsByContract();
    },
    async removeContractAsset() {
      try {
        this.isLoading = true;
        await this.$store.dispatch("contractAsset/removeContractAsset", {
          id: this.checkList.objectId
        });
        this.isDeleteAsset = false;
        this.isCheckList = false;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onSaveChecklist() {
      this.setSelectAreas(false);
      this.isSelect = false;
      this.getContractAssetsByContract();
    },
    preDelete(objectId) {
      this.isDeleteAsset = true;
      this.checkList.objectId = objectId;
    },
    countSelect() {
      let count = 0;
      for (const key in this.selectAreas) {
        const element = this.selectAreas[key];
        if (element.isSelect) {
          count++;
        }
      }
      return count;
    },
    setSelectAreas(s = false) {
      this.isToggle = true;
      for (const key in this.selectAreas) {
        this.selectAreas[key].isSelect = s;
      }
      this.isToggle = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.asd {
  border-radius: 5px;
}
</style>